type DecimalLike = {
  toString: () => string
}

export const mapStringToBoolean = (value: string): boolean => (value === 'true' ? true : false)

export const mapBooleanToString = (value: boolean) => (value === true ? 'true' : 'false')

export const mapCommaSeperatedStringToArray = (value: string | null): string[] =>
  value ? value.split(',') : []

export const mapArrayToCommaSeperatedString = (value: string[] | null): string | null =>
  value ? value.join(',') : null

export const mapDecimalToString = (value: DecimalLike | null): string | null =>
  value ? Number(value.toString()).toFixed(2) : ''

export const mapDecimalStringForBackend = (value: string | null): string | null =>
  value && value !== '' ? value : null

export const mapStringToNumber = (value: string | null): number | null =>
  value && value !== '' ? Number.parseInt(value, 10) : null

export const mapNumberToString = (value: number | null): string | null =>
  value !== null && value !== undefined ? value.toString() : null

type UnknownArrayOrObject = unknown[] | Record<string, unknown>

// todo: fix these type definitions
export const dirtyValues = (dirtyFields: any, allValues: any): UnknownArrayOrObject => {
  if (Array.isArray(dirtyFields)) {
    return dirtyFields.map((el, index) => {
      return Object.fromEntries(Object.keys(el).map((key) => [key, allValues[index][key]]))
    })
  }

  return Object.fromEntries(
    Object.keys(dirtyFields).map((key) => [key, dirtyValues(dirtyFields[key], allValues[key])])
  )
}
